/* eslint-disable @typescript-eslint/no-explicit-any */

interface CouponFieldProps {
  couponInput: string;
  couponApplied: any;
  couponError: boolean;
  /** Mensagem da recusa (ex.: "não vale para este plano"); sem ela, a genérica. */
  couponErrorMessage?: string | null;
  onInputChange: (value: string) => void;
  onApply: () => void;
  onRemove: () => void;
}

export function CouponField({
  couponInput,
  couponApplied,
  couponError,
  couponErrorMessage,
  onInputChange,
  onApply,
  onRemove,
}: CouponFieldProps) {
  if (couponApplied) {
    return (
      <div className="flex items-center justify-between bg-gray-100 px-4 py-2 rounded-lg">
        <div className="flex items-center gap-2 text-gray-700 font-medium">
          <img src="/icon-tag.svg" className="w-5 h-5" />
          {couponApplied?.code || 'Cupom aplicado'}
        </div>
        <button onClick={onRemove} className="text-gray-400 hover:text-red-500 text-xl">
          &times;
        </button>
      </div>
    );
  }

  return (
    <>
      <div className="flex items-center justify-between">
        <input
          type="text"
          className={`flex-1 border rounded-lg px-3 py-2 ${couponError ? 'border-red-500' : 'border-black/10'}`}
          placeholder="Digite seu cupom"
          value={couponInput}
          onChange={(e) => onInputChange(e.target.value)}
        />
        <button
          onClick={onApply}
          className="ml-3 py-2 px-6 border rounded-lg text-[#018ED5] border-[#018ED5] hover:opacity-90 hover:cursor-pointer"
        >
          Aplicar
        </button>
      </div>
      {couponError && (
        <span className="text-sm text-red-500 mt-1">{couponErrorMessage || 'Cupom inválido ou expirado.'}</span>
      )}
    </>
  );
}
